export { default as RecaptchaSize } from './recaptcha-size';
